import React from 'react';
import { StarIcon, TimerIcon, CheckIcon, SnowflakeIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { TRUST_POINTS } from '../data/site';
import { BuyButton } from './ui/BuyButton';
import { OrnamentCarousel } from './OrnamentCarousel';
const HERO_VIDEO = 'https://cdn.magicpatterns.com/uploads/rHjJiVrZWTMwgBwtu8Z1wE/IMG_4432.MOV';
interface HeroProps {
  countdown: {
    hours: string;
    minutes: string;
    seconds: string;
  };
  showCountdown?: boolean;
}
export function Hero({
  countdown,
  showCountdown = true
}: HeroProps) {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-45" data-mp="sb1chsl5257m">
      <div className="bg-sage-800 py-2 text-center" data-id="element-46" data-mp="sde3ev8vjpwt">
        <p className="flex flex-wrap items-center justify-center gap-x-2 px-4 text-[10px] font-bold uppercase tracking-[0.16em] text-gold-200 sm:text-[11px] sm:tracking-overline" data-id="element-47" data-mp="nczrh245jvti">
          <SnowflakeIcon className="h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-48" data-mp="382p91mw8pvpw" />
          Producto 100% digital · acceso inmediato
        </p>
      </div>
      {showCountdown ? <div className="bg-terracotta-500 py-2 text-center" data-id="element-49" data-mp="3j6odfogqqus7">
          <p className="flex flex-wrap items-center justify-center gap-x-2 px-4 text-[11px] font-semibold uppercase tracking-wide text-cream sm:text-[12px]" data-id="element-50" data-mp="3o6aru18b2h2l">
            <TimerIcon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-51" data-mp="3e961dp7ffzfz" />
            Oferta navideña por tiempo limitado:{' '}
            <span className="font-bold" data-id="element-52" data-mp="30h9d5w8vq9ov">
              {countdown.minutes}:{countdown.seconds}
            </span>
          </p>
        </div> : null}

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-4 pb-10 pt-8 sm:gap-10 sm:px-8 sm:pb-14 sm:pt-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:pb-20 lg:pt-14" data-id="element-53" data-mp="2qjv8etwbj9ce">
        {/* Video principal */}
        <div className="order-1 lg:order-2" data-id="element-54" data-mp="2hjf63nrba894">
          <div className="relative mx-auto w-full max-w-[290px] pb-6 sm:max-w-[360px] lg:max-w-none" data-id="element-55" data-mp="2hkglg4fd1gwn">
            <video src={HERO_VIDEO} autoPlay loop muted playsInline preload="metadata" aria-label="Video de esferas navideñas decoradas a mano" className="aspect-[9/16] w-full rounded-[1.75rem] bg-shell object-cover shadow-[0_30px_60px_-30px_rgba(14,35,21,0.5)] sm:rounded-[2rem]" data-id="element-56" data-mp="2lk8v6kghpt3l" />
            <div className="absolute bottom-0 left-1/2 flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full border border-gold-200/70 bg-cream px-4 py-2 shadow-[0_18px_36px_-20px_rgba(14,35,21,0.4)] sm:px-5 sm:py-2.5" data-id="element-57" data-mp="id9tudnwcbtt">
              <span className="font-serif text-[18px] font-semibold leading-none text-terracotta-500 sm:text-[20px]" data-id="element-58" data-mp="1ayt710s27lbf">
                +80
              </span>
              <span className="text-[10.5px] font-semibold uppercase tracking-wider text-sage-800 sm:text-[11.5px]" data-id="element-59" data-mp="111omt6hrxzx9">
                técnicas paso a paso
              </span>
            </div>
          </div>
        </div>

        {/* Texto */}
        <div className="order-2 text-center lg:order-1 lg:pt-4 lg:text-left" data-id="element-60" data-mp="3lqm1dvdxqztc">
          <p className="inline-flex items-center justify-center gap-2 rounded-full border border-gold-200/60 bg-bone px-3.5 py-1.5 text-[9.5px] font-bold uppercase tracking-[0.18em] text-terracotta-600 sm:px-4 sm:text-[10.5px] sm:tracking-[0.2em]" data-id="element-61" data-mp="3hq250u16s089">
            Pintar · Decorar · Personalizar
          </p>

          <h1 className="mt-5 font-serif text-[1.95rem] leading-[1.12] text-sage-900 sm:mt-6 sm:text-[2.7rem] sm:leading-[1.07] lg:text-[3.4rem]" style={{
          fontWeight: '600'
        }} data-id="element-62" data-mp="268oblkph19t2">
            Crea esferas navideñas únicas y{' '}
            <span className="italic text-terracotta-500" data-id="element-63" data-mp="2kydt4qhvfqfi">
              transforma tu árbol
            </span>{' '}
            en algo especial
          </h1>

          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-ink-soft sm:mt-6 sm:text-[17px] lg:mx-0" data-id="element-64" data-mp="2oye606pbntkg">
            Aprende +80 técnicas para personalizar esferas navideñas con
            plantillas y métodos fáciles de seguir.
          </p>

          <div className="mt-7 flex flex-col items-center gap-3 lg:items-start" data-id="element-65" data-mp="zmlxsbj69wjb">
            <BuyButton size="xl" label="Quiero crear mis esferas" href="#oferta" className="w-full sm:w-auto" data-id="element-66" data-mp="4al077oyb0k7" />
            <p className="text-[12px] font-medium text-ink-light sm:text-[12.5px]" data-id="element-67" data-mp="3vgni4u78vzrw">
              Acceso inmediato · desde cualquier dispositivo
            </p>
          </div>

          <p className="mx-auto mt-6 max-w-xl rounded-3xl border border-gold-200/60 bg-bone px-4 py-4 text-[13.5px] font-medium leading-relaxed text-sage-800 sm:px-5 sm:text-[14.5px] lg:mx-0" data-id="element-68" data-mp="99xm9q8003lq">
            Perfecto para decorar tu hogar, hacer regalos personalizados o crear
            productos para vender esta Navidad.
          </p>

          <div className="mt-6 flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-4 lg:justify-start" data-id="element-69" data-mp="3rhn19h8bv77j">
            <div className="flex items-center gap-3" data-id="element-70" data-mp="3mnah14z11ruq">
              <div className="flex -space-x-2" data-id="element-71" data-mp="2yyr76l0bx70j">
                {testimonials.slice(0, 3).map(t => <img key={t.name} src={t.avatar} alt="" className="h-8 w-8 rounded-full border-2 border-cream object-cover" data-id="element-72" data-mp="2u17w1tyxhact" />)}
              </div>
              <div className="flex items-center gap-0.5" data-id="element-73" data-mp="19hcfm3zqhn9k">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-74" data-mp="zkhkzw6l070k" data-mpi={i} />)}
              </div>
            </div>
            <p className="text-center text-[12.5px] font-medium leading-snug text-sage-800 sm:text-left" data-id="element-75" data-mp="14kcabvapkoji">
              <span className="font-semibold" data-id="element-76" data-mp="1sagafsoou65r">4.9 / 5</span> · miles de mujeres ya
              crearon su primera esfera
            </p>
          </div>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 lg:justify-start" data-id="element-77" data-mp="1j8qm4vq3rnc7">
            {TRUST_POINTS.map(item => <li key={item} className="flex items-center gap-1.5 text-[12.5px] font-medium text-sage-800 sm:text-[13px]" data-id="element-78" data-mp="1n90olyeorvmb">
                <CheckIcon className="h-4 w-4 flex-none text-sage-500" aria-hidden="true" data-id="element-79" data-mp="7s0a2vz001ao" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      {/* Carrusel de inspiración */}
      <div className="relative pb-12 sm:pb-16 lg:pb-20" data-id="element-80" data-mp="2ejn2xng9o4d5">
        <OrnamentCarousel duration="50s" data-id="element-81" data-mp="29jilnv7jb5lv" />
        <div className="pointer-events-none absolute bottom-12 left-0 top-0 w-8 bg-cream sm:bottom-16 sm:w-14 lg:bottom-20" style={{
        maskImage: 'linear-gradient(to right, #000, transparent)',
        WebkitMaskImage: 'linear-gradient(to right, #000, transparent)'
      }} aria-hidden="true" data-id="element-82" data-mp="29kk8ewxwxgjf" />
        <div className="pointer-events-none absolute bottom-12 right-0 top-0 w-8 bg-cream sm:bottom-16 sm:w-14 lg:bottom-20" style={{
        maskImage: 'linear-gradient(to left, #000, transparent)',
        WebkitMaskImage: 'linear-gradient(to left, #000, transparent)'
      }} aria-hidden="true" data-id="element-83" data-mp="1vopz4ct88p5s" />
      </div>
    </header>;
}